import { useState } from "react";
import { motion } from "framer-motion";
import PROCESS_STEPS from "@/data/processData";
import DetailsModal from "@/components/landing/DetailsModal";

export default function Process() {
  const [active, setActive] = useState(null);

  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative py-14 md:py-32 overflow-hidden border-y border-white/5 bg-[#070709]"
    >
      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl mb-10 md:mb-16">
          <div className="text-[10px] font-mono-acc uppercase tracking-[0.3em] text-cyan-400 mb-3">
            / How we operate
          </div>
          <h2 className="font-clash text-3xl md:text-5xl font-semibold tracking-tight leading-[1.05]">
            Six steps. <span className="text-gradient-neon">One growth machine.</span>
          </h2>
          <p className="mt-5 text-zinc-400 text-base md:text-lg leading-relaxed">
            A repeatable, transparent engagement model used across every client
            — from Series A startups to publicly listed brands. Tap any step
            to see what happens, when, and what you walk away with.
          </p>
        </div>

        <div className="relative">
          {/* Connector line (desktop) */}
          <div className="hidden md:block absolute left-0 right-0 top-[42px] h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" />

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-3">
            {PROCESS_STEPS.map((s, i) => (
              <motion.button
                type="button"
                key={s.n}
                onClick={() => setActive(s)}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.5, delay: i * 0.07 }}
                className="relative group text-left"
                data-testid={`process-step-${s.n}`}
              >
                <div className="relative flex items-center justify-center mb-6">
                  <div className="relative h-[18px] w-[18px] rounded-full bg-[#070709] border border-white/15 z-10">
                    <span className="absolute inset-1 rounded-full bg-gradient-to-br from-cyan-400 to-purple-500 pulse-dot" />
                  </div>
                </div>
                <div className="rounded-2xl glass p-5 hover:bg-white/[0.04] hover:-translate-y-0.5 transition-all duration-300 h-full ring-glow">
                  <div className="font-mono-acc text-[11px] tracking-widest text-zinc-500">
                    STEP / {s.n}
                  </div>
                  <h3 className="mt-2 font-clash text-lg font-medium text-white">{s.name}</h3>
                  <p className="mt-2 text-sm text-zinc-400 leading-relaxed">{s.tagline}</p>
                  <div className="mt-4 text-[11px] text-zinc-500 group-hover:text-cyan-300 transition-colors">
                    See the playbook →
                  </div>
                </div>
              </motion.button>
            ))}
          </div>
        </div>
      </div>

      {active && (
        <DetailsModal
          item={active}
          onClose={() => setActive(null)}
          testIdPrefix="process-details"
        />
      )}
    </section>
  );
}
